import React, {Component} from 'react';
import {observer} from 'mobx-react';
import styles from './index.css';
import {Popup} from '../index';
import settings from "../../../../stores/cultureSettings";

@observer
export default class Hopper extends Component{
    state = {active:false};
    coords(e){
        let target = e.target;
        let X = target.getBoundingClientRect().right + 4;
        let Y = target.getBoundingClientRect().top - 14;
        this.setState({active:true,x:X,y:Y})
    }
    
  render() {
        let item = this.props.item;
        let levelHeight = {height:(item.amount/ (item.totalCapacity * Math.pow(settings[item.culture].volume,2))) * 100 + '%'};
      return (
        <div className={styles.hopperContainer + (this.props.inPath ? ' ' + styles.inPath : '')}>
          <div className={styles.hopper
          + (item.culture ? ' ' + styles[item.culture] : '')
          + ' ' + styles[item.status]}
          onMouseOver={this.coords.bind(this)} onMouseLeave={()=>this.setState({active:false})}>
            <div className={styles.hopperLevel} style={levelHeight}/>
            <div className={styles.hopperNumbers}>
              <span>{Math.ceil(item.amount)}</span>
              <hr />
              <span>{Math.ceil(item.totalCapacity * settings[item.culture].volume)}</span>
            </div>
            <div className={styles.cloggedHopper}>!</div>
          </div>
          {this.state.active ?
            <Popup x={this.state.x} y={this.state.y} item={item}/> : null
          }
        </div>
      )
  }
}


// WEBPACK FOOTER //
// ./src/shared/components/Game/SubComponents/Hopper/index.js